import { Injectable } from '@angular/core';
import { HttpService, IResponse, IResponseLower } from 'core-max-lib';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AppConfigsService } from '../../../config/app-configs.service';
import {
    IDebtOtpRequest,
    IDebtValidateCode,
    IDebtWithInquiryNumberRequest,
    IPayDebtRequest
} from '../interfaces/debts-request.interface';
import { IGetDebtsResult, IPayDebtResult } from '../interfaces/debts-result.inteface';
import { IDebtPaymentContent } from '../interfaces/debts-content.interface';

@Injectable({
    providedIn: 'root'
})
export class DebtPaymentService {
    id: string;
    next: string;
    debts: IGetDebtsResult;
    sumToPay: number;
    errorRC: number;
    loader = false;
    content: IDebtPaymentContent;
    isComponentNeedContainer = false;

    constructor(private httpSvc: HttpService, private appConfigsService: AppConfigsService) {}

    GetContent(): Observable<IResponseLower<IDebtPaymentContent>> {
        this.loader = true;
        return this.httpSvc
            .getLower<IDebtPaymentContent>(
                `${this.appConfigsService.appConfigs.apiUrl}/registered/debtPayment/getContent`
            )
            .pipe(
                tap(x => {
                    this.loader = false;
                    if (x.returnCode === 0) {
                        this.content = x.result;
                        return;
                    }
                })
            );
    }

    SendVerificationForId(req: IDebtOtpRequest): Observable<IResponseLower<any>> {
        this.loader = true;
        return this.httpSvc
            .postLower(`${this.appConfigsService.appConfigs.apiUrl}/registered/debtPayment/sendVerificationForId`, req)
            .pipe(
                tap(x => {
                    this.loader = false;
                })
            );
    }

    ValidateCodeAndGetDebts(req: IDebtValidateCode): Observable<IResponseLower<IGetDebtsResult>> {
        this.loader = true;
        return this.httpSvc
            .postLower<IGetDebtsResult>(
                `${this.appConfigsService.appConfigs.apiUrl}/registered/debtPayment/validateCodeAndGetDebts`,
                req
            )
            .pipe(
                tap(x => {
                    this.loader = false;
                })
            );
    }

    GetDebts(): Observable<IResponseLower<IGetDebtsResult>> {
        this.loader = true;
        return this.httpSvc
            .postLower<IGetDebtsResult>(
                `${this.appConfigsService.appConfigs.apiUrl}/registered/debtPayment/getDebts`,
                {}
            )
            .pipe(
                tap(x => {
                    this.loader = false;
                })
            );
    }

    GetDebtsWithInquiryNumber(req: IDebtWithInquiryNumberRequest): Observable<IResponseLower<IGetDebtsResult>> {
        this.loader = true;
        return this.httpSvc
            .postLower<IGetDebtsResult>(
                `${this.appConfigsService.appConfigs.apiUrl}/registered/debtPayment/getDebtsWithInquiryNumber`,
                req
            )
            .pipe(
                tap(x => {
                    this.loader = false;
                })
            );
    }

    PayDebts(payReq: IPayDebtRequest): Observable<IResponseLower<IPayDebtResult>> {
        this.loader = true;
        return this.httpSvc
            .postLower<IPayDebtResult>(
                `${this.appConfigsService.appConfigs.apiUrl}/registered/debtPayment/payDebt`,
                payReq
            )
            .pipe(
                tap(x => {
                    this.loader = false;
                })
            );
    }
}
